import { useQuery } from '@apollo/client';
import { ApolloProviderV4 } from '~/apollo/client-v4';
import { graphql } from '~/apollo/generated/v4';
import { BookmarkParentType } from '~/apollo/generated/v4/graphql';
import { SpinnerPlaceholder } from '~/components/common/SpinnerPlaceholder';
import { SOItemListV4 } from '~/components/supporting-object/so-item-list-v4';
import { useRouteParam } from '~/hooks/routing';
import { createRefetchQueries } from '~/utils/graphql';

const STUDY_PRODUCTION_PAGE = graphql(`
  query StudyProductionPage($id: ID!) {
    studyGet(id: $id) {
      id
      production {
        ...productionParts
        pictures {
          ...soPictureParts
        }
        files {
          ...fileParts
        }
      }
    }
  }
`);

export default function StudyProductionPage() {
  return (
    <ApolloProviderV4>
      <StudyProductionPageInner />
    </ApolloProviderV4>
  );
}

function StudyProductionPageInner() {
  const studyId = useRouteParam('studyId', parseInt);

  const { data, loading } = useQuery(STUDY_PRODUCTION_PAGE, {
    variables: { id: studyId },
  });

  const refetchQueries = createRefetchQueries([
    { query: STUDY_PRODUCTION_PAGE, variables: { id: studyId } },
  ]);

  const production = data?.studyGet?.production ?? [];

  if (loading) return <SpinnerPlaceholder />;

  return (
    <SOItemListV4
      items={production}
      soParentType="study"
      soParentId={studyId}
      bookmarkParentType={BookmarkParentType.Production}
      refetchQueries={refetchQueries}
    />
  );
}
